import agentApi from '@/service/device/agent'

/////////////////////////////////////////////////////////////////////////////////////   api接口

// 设备签名 - 使用 WebSocket agent
export const deviceSign = async (params: any) => {
  try {
    const response = await agentApi.post('/api/device/sign', params)
    // 返回格式与 axios 兼容
    return {
      status: 200,
      data: response.data
    }
  } catch (error) {
    console.log('设备签名失败:', error)
    throw error
  }
}
